import "./ScrollIndicator.scss";
import { define, mount } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";

class ScrollIndicator implements Component {
  readonly el: HTMLElement;

  private readonly onShow = () => {
    if (this.isInsideScrollytelling()) {
      this.show();
    }
  };
  private readonly onHide = () => this.hide();

  constructor(el: HTMLElement) {
    this.el = el;
    mount(el);
    window.addEventListener("scrollIndicator:show", this.onShow);
    window.addEventListener("scrollIndicator:hide", this.onHide);
  }

  private isInsideScrollytelling(): boolean {
    const scrollY = window.scrollY;
    const sections = document.querySelectorAll<HTMLElement>(
      "[data-scrollytelling]"
    );

    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + scrollY;
      const sectionBottom = sectionTop + section.offsetHeight;

      if (scrollY >= sectionTop && scrollY < sectionBottom) {
        return true;
      }
    }

    return false;
  }

  show(): void {
    this.el.classList.add("scroll-indicator--visible");
  }

  hide(): void {
    this.el.classList.remove("scroll-indicator--visible");
  }

  destroy(): void {
    window.removeEventListener("scrollIndicator:show", this.onShow);
    window.removeEventListener("scrollIndicator:hide", this.onHide);
  }
}

define("scroll-indicator", (el) => new ScrollIndicator(el));
export { ScrollIndicator };
